module.exports = __webpack_public_path__ + "media/images/lb/924-0c7603e9d19b2397cc145bd5478e65f3.svg";